'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = feedItems;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function populateFeedItem(state, action) {
  var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var key = action.payload.feedContentId;
  if (state[key]) return Object.assign({}, state[key], overwrite);
  return overwrite;
}

function feedItems() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var newState = void 0;
  switch (action.type) {
    case _actionTypes.ADD_FEED_ITEMS:
      newState = {};
      if (action.payload.feedItems) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = action.payload.feedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var feedItem = _step.value;

            newState[feedItem.content.feedContentId] = feedItem;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return Object.assign({}, state, newState);
    case _actionTypes.RECEIVE_MINI_PROFILE:
    case _actionTypes.RECEIVE_USER_TIMELINE:
      newState = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = action.payload.response.feedItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _feedItem = _step2.value;

          newState[_feedItem.content.feedContentId] = _feedItem;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return Object.assign({}, state, newState);
    case _actionTypes.REQUEST_FEED_ITEM:
      var requestedFeedItem = populateFeedItem(state, action, { isFetching: true, isError: false });
      return Object.assign({}, state, _defineProperty({}, action.payload.feedContentId, requestedFeedItem));
    case _actionTypes.FAIL_FEED_ITEM:
      var failedFeedItem = populateFeedItem(state, action, { isFetching: false, isError: true });
      return Object.assign({}, state, _defineProperty({}, action.payload.feedContentId, failedFeedItem));
    case _actionTypes.RECEIVE_FEED_ITEM:
      var receivedFeedItem = populateFeedItem(state, action, _extends({
        isFetching: false,
        isError: false
      }, action.payload.response));
      return Object.assign({}, state, _defineProperty({}, action.payload.feedContentId, receivedFeedItem));
    default:
      return state;
  }
}